import { render } from "./HealthTestMessageModal.vue?vue&type=template&id=b828b7c2&scoped=true"
import script from "./HealthTestMessageModal.vue?vue&type=script&lang=js"
export * from "./HealthTestMessageModal.vue?vue&type=script&lang=js"

import "./HealthTestMessageModal.vue?vue&type=style&index=0&id=b828b7c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b828b7c2"]])

export default __exports__